/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const ConcentricCirclesIcon: React.FC<
  AllieIconProps & { width?: string; height?: string }
> = ({ width = '481', height = '474', color = 'var(--allie-color-secondary-10)', ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 481 474"
    fill="none"
    {...rest}
  >
    <circle cx="240.5" cy="234" r="47.5" stroke="#EAECF0" />
    <circle cx="240.5" cy="234" r="79.5" stroke="#EAECF0" />
    <circle cx="240.5" cy="234" r="111.5" stroke="#EAECF0" />
    <circle cx="240.5" cy="234" r="143.5" stroke="#EAECF0" />
    <circle cx="240.5" cy="234" r="143.5" stroke="#EAECF0" />
    <circle cx="240.5" cy="234" r="175.5" stroke="#EAECF0" />
    <circle cx="240.5" cy="234" r="207.5" stroke="#EAECF0" />
    <circle cx="240.5" cy="234" r="239.5" stroke="#EAECF0" />

    <circle cx="240.5" cy="234" r="28" fill={color} />

    <image x="226.5" y="220" width="28" height="28" href="assets/icon-bg-fgpt.gif" />
  </svg>
);
